<template>
  <div class="field-input" :class="{ 'has-error': $validator.errors.has(name, validateScope) }">
    <el-select v-model="internalValue" :disabled="disabled === true" :readonly="readonly === true"
               :no-data-text="noDataText" :clearable="clearable"
               :placeholder="placeholder" :name="name" v-validate="validate" :data-vv-as="validateLabel"
               @visible-change="onSelectVisibleChange">
      <slot></slot>
    </el-select>
    <span class="error-message"><strong>{{$validator.errors.first(name, validateScope)}}</strong></span>
  </div>
</template>

<script lang="js">

export default {
  name: 'FieldSelectCmp',
  components: {},
  props: {
    value: null,
    name: '',
    placeholder: null,
    validate: null,
    validateLabel: '',
    validateScope: null,
    disabled: {type: Boolean, default: false},
    readonly: {type: Boolean, default: false},
    noDataText: {type: String, default: '選択可能なオプションがありません'},
    clearable: {type: Boolean, default: false}
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data () {
    return {
      internalValue: this.value
    }
  },
  watch: {
    value (newValue) {
      this.internalValue = newValue
    },
    internalValue (newValue) {
      this.$emit('change', newValue)
    }
  },
  methods: {
    onSelectVisibleChange (visible) {
      // fix bug edge crash
      const isEdge = window.navigator.userAgent.includes('Edge')
      if (isEdge && !visible) {
        document.querySelectorAll('body > .el-select-dropdown.el-popper').forEach((it) => it.remove())
      }
    }
  }
}

</script>
<style scoped>
  .field-input {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/field/select.vue